module.exports = __webpack_public_path__ + "img/ic_blue_dropdown copy.5e782610.svg";